<template>
	<div class="page">
		<img :src="headImg" v-if="headImg" class="bg" alt="" />

		<div class="content w1200">
			<div class="dept">
				<div class="dept_top">
					<div class="tab-buttons">
						<div v-for="(tab, index) in tabs" :key="index" @click="bindTabs(tab)" class="tab"
							:class="{ active: activeTab === tab.id }">
							{{ tab.name }}
						</div>
						
					</div>
					<div class="search">
						<div class="search_left">
							<img src="@/assets/icon.png" class="sear_icon" alt="" />
							<input type="text" :placeholder="activeTab == 0 ? '搜索展商名称' : '搜索展品名称'" v-model="key"
								class="input" name="" id="" />
						</div>
						<div class="search_btn" @click="bindSearch">搜索</div>
					</div>
					<div class="tip">展商及展品按上传时间先后排序</div>
				</div>
				<!-- 参展商list -->
				<div v-if="activeTab == 0" class="card_box">
					<div v-for="(item, index) in exList" :key="index" @click="bindDetails(item)" class="card">
						<div class="logo">
							<el-image :src="item.Logo ? item.Logo : require('@/assets/logo.png')" class="logo_img"
								fit="contain"></el-image>
						</div>

						<div class="card_right">
							<div class="name">{{ item.CiComName }}</div>
							<div class="sub_name">展位号：{{ item.ExtCode }}</div>
							<div class="sub_name2">
								<div class="sub_left">公司介绍：</div>
								<div class="sub_right">{{ item.CiIntro }}</div>
							</div>
						</div>
					</div>
					<div class="empty">
						<el-empty description="暂无" v-if="exList.length == 0"></el-empty>
					</div>
				</div>
				<!-- 展品list -->
				<div v-if="activeTab == 1" class="card_box2">
					<div v-for="item in proList" :key="item.EpID" @click="bindProductDetails(item)" class="card_row">
						<el-image :src="item.EpImage" v-if="item.EpImage" class="logo" fit="contain"></el-image>
						<div class="card_right">
							<div class="name">{{ item.EpTitle }}</div>
							<div class="sub_name">展位号：{{ item.ExtCode }}</div>
							<div class="sub_name2">{{ item.EpInfo }}</div>
						</div>
					</div>
					<div class="empty">
						<el-empty description="暂无" v-if="proList.length == 0"></el-empty>
					</div>
				</div>

				<div class="pagination">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="page" :page-size="limit"
						:total="total" layout=" prev, pager, next">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		isMobileDevice
	} from "@/utils/deviceCheck";
	export default {
		data() {
			return {
				data: [],
				currentPage1: 1,
				exhid: "",
				headImg: "",
				key: "",
				flag: false,
				tabs: [{
						id: 0,
						name: "参展商",
					}
				],

				limit: 12,
				page: 1,
				total: 0,
				ExtID: "",
				exList: [],
				proList: [],
			};
		},
		created() {
			if (this.$route.query) {
				this.exhid = this.$route.query.exhid;
				this.fetchData();
				this.getProList();
				this.getImg();
				if (isMobileDevice()) {
					window.location.href = `https://hkh5.eainfor.com/#/?exhid=${this.$route.query.exhid}`;
				}
			}
		},
		computed: {
			activeTab() {
				return this.$store.state.activeTab;
			},
		},
		mounted() {},
		methods: {
			//点击切换bindTabs
			bindTabs(item) {
				if (item == this.activeTab) {
					return;
				}
				this.updateActiveTab(item.id);
				this.page = 1;
				this.key = "";
				if (item.id == 0) {
					console.log("点击切换bindTabs1", item);
					this.exList = [];
					this.fetchData();
				} else if (item.id == 1) {
					console.log("点击切换bindTabs2", item);
					this.proList = [];
					this.getProList();
				}
			},
			updateActiveTab(tab) {
				this.$store.commit("setActiveTab", tab);
			},
			changeInput(e) {
				this.key = e.data;
			},
			bindSearch() {
				let that = this;
				// if (!that.key) {
				//   this.$message({
				//     message: '请输入要搜索参展商名称或展位号',
				//     type: 'warning'
				//   });
				//   return
				// }
				this.page = 1;
				this.exList = [];
				this.proList = [];
				if (that.activeTab == 0) {
					this.fetchData();
				} else if (that.activeTab == 1) {
					this.getProList();
				}
			},
			getImg() {
				let that = this;
				let url = `/Exh/settings/${that.exhid}?type=0`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						console.log("获取图片", res);
						if (res.data.data.isShowPdt == 1) {
							that.tabs = [{
									id: 0,
									name: "参展商",
								},
								{
									id: 1,
									name: "参展产品",
								},
							]
						} else {
							that.tabs = [{
								id: 0,
								name: "参展商",
							}, ]
						}
						that.headImg = res.data.data.pc_banner;
						document.title = res.data.data.title ? res.data.data.title : '';
					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
			handleCurrentChange(val) {
				let that = this;
				that.page = val;
				if (that.activeTab == 0) {
					that.fetchData();
				} else if (that.activeTab == 1) {
					that.getProList();
				}

				console.log(`当前页: ${val}`);
			},
			fetchData() {
				let that = this;
				let url =
					`/Exh/exhibitorList/${that.exhid}?key=${that.key}&limit=${that.limit}&page=${that.page}`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						console.log("获取列表", res);
						that.exList = res.data.data.list;
						that.total = Number(res.data.data.count);
					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
			getProList() {
				let that = this;
				let url =
					`/Exh/extProductList/${that.exhid}?key=${that.key}&ExtID=${that.ExtID}&limit=${that.limit}&page=${that.page}`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						console.log("获取列表", res);
						that.proList = res.data.data.list;

						that.total = Number(res.data.data.count);
					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
			//点击跳转展商详情
			bindDetails(item) {
				let that = this;
				this.$router.push({
					path: `/Details?exhid=${that.exhid}&ExtID=${item.ExtID}`,
				});
			},
			//点击跳转展品详情
			bindProductDetails(item) {
				let that = this;
				this.$router.push({
					path: `/productDetail?exhid=${that.exhid}&EpID=${item.EpID}`,
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.page {
		background: #f6f6f6;
		position: absolute;
		width: 100%;
		min-height: 100%;
	}

	.empty {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.bg {
		display: block;
		width: 100%;
	}

	.content {
		margin-top: 56px;
		padding-bottom: 80px;
	}

	.dept {
		.tab-buttons {
			display: flex;

			.tab {
				width: 149px;
				height: 60px;
				cursor: pointer;
				border: none;
				margin-right: 5px;
				font-weight: 500;
				font-size: 20px;
				color: #333333;
				text-align: center;
				line-height: 60px;
			}

			.active {
				width: 149px;
				height: 60px;
				cursor: pointer;
				background: #218cdf;
				font-size: 20px;
				text-align: center;
				color: #fefefe;
				line-height: 60px;
			}
		}

		.search {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.search_left {
				width: 1000px;
				height: 65px;
				background: #ffffff;
				border: 2px solid #218cdf;
				display: flex;
				align-items: center;

				.sear_icon {
					width: 25px;
					height: 25px;
					padding-left: 50px;
				}

				.input {
					width: 800px;
					box-sizing: border-box;
					height: calc(100% - 2px);
					border: none;
					outline: none;
					padding-left: 33px;
					font-weight: 500;
					font-size: 18px;
					color: #333333;
					line-height: 32px;
				}
			}

			.search_btn {
				width: 150px;
				height: 64px;
				background: #218cdf;
				font-weight: 400;
				font-size: 26px;
				color: #ffffff;
				text-align: center;
				line-height: 64px;
				cursor: pointer;
			}
		}
	}

	.pagination {
		display: flex;
		justify-content: center;
		margin-top: 50px;
	}

	.card_box {
		display: flex;
		flex-wrap: wrap;

		.card {
			width: 520px;
			height: 175px;
			padding: 56px 44px 54px 23px;
			background: linear-gradient(-90deg, rgba(255, 255, 255), #eef8ff);
			margin-top: 27px;
			display: flex;
			cursor: pointer;

			.logo {
				width: 176px;
				height: 176px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: #ffffff;
				flex-grow: 0;
				flex-shrink: 0;
				border-radius: 7px;
				border: 1px solid #c4c4c4;
				margin-right: 22px;
			}

			.card_right {
				.name {
					font-weight: 500;
					font-size: 21px;
					color: #333333;
					line-height: 24px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.sub_name {
					font-weight: 400;
					font-size: 18px;
					color: #333333;
					line-height: 24px;
					background: #e7f4fe;
					padding: 5px 10px;
					display: inline-block;
					margin: 14px 0 4px 0;
				}

				.sub_name2 {
					display: flex;
					justify-content: flex-start;
					align-items: flex-start;

					.sub_left {
						// flex: 1;
						font-weight: 400;
						width: 100px;
						font-size: 18px;
						color: #333333;
						line-height: 35px;
					}

					.sub_right {
						-webkit-line-clamp: 3;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
						text-overflow: ellipsis;
						font-weight: 400;
						font-size: 18px;
						width: 200px;
						color: #999;
						line-height: 35px;
					}
				}
			}
		}

		.card:nth-child(2n + 1) {
			margin-right: 23px;
		}
	}

	.card_box2 {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.card_row {
		width: 266px;
		height: 428px;
		background: #ffffff;
		margin-top: 68px;
		display: flex;
		flex-direction: column;
		margin-right: 40px;
		cursor: pointer;

		.logo {
			width: 260px;
			height: 199px;
			padding-top: 34px;
			padding-bottom: 18px;
			border-bottom: 1px solid #d1dbe5;
		}

		.card_right {
			padding-left: 10px;

			.name {
				font-weight: 700;
				font-size: 23px;
				color: #333333;
				line-height: 35px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.sub_name {
				font-weight: 500;
				font-size: 20px;
				color: #333333;
				line-height: 35px;
				display: inline-block;
			}

			.sub_name2 {
				-webkit-line-clamp: 2;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
				font-weight: 400;
				font-size: 18px;
				width: 240px;
				color: #333;
				line-height: 35px;
			}
		}
	}

	.card_row:nth-child(4n) {
		margin-right: 0px;
	}

	.card:nth-child(4) {
		margin-right: 0px;
	}
	.tip{
		display:flex;
		color:red;
		align-items: center;
		font-size:18px;
		font-weight: 600;
		margin-top:10px;
	}
</style>